<template>
	<div class="branch-wrap">
		<div class="branch-box-wrap">
			<div class="branch-box" >
				<div class="col-box">
					<flow-node :_config="_config" :_parent="_parent" :_define="_define" @del-node="_parent.children.splice(_index,1)" @node-click="(v)=>$emit('node-click',v)"></flow-node>
					<div class="top-left-cover-line"></div>
					<div class="bottom-left-cover-line"></div>
					<flow-action :nodes="_define.nodes" @add-node="handlerAddNode"></flow-action>
				</div>
				<div class="col-box iterator-node">
					<!--					子节点-->
					<iterator-item-node :_config="_config" :_parent="_parent" :_define="_define" @node-click="(v)=>$emit('node-click',v)"></iterator-item-node>
					<div class="top-right-cover-line"></div>
					<div class="bottom-right-cover-line"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import FlowRender from "@/components/flow/flow-render.vue";
import ConditionNode from "@/components/flow/nodes/condition-node.vue";
import BranchAction from "@/components/flow/nodes/branch-action.vue";
import FlowAction from "@/components/flow/nodes/flow-action.vue";
import AddAction from "@/components/flow/nodes/flow-action.vue";
import FlowNode from "@/components/flow/nodes/flow-node.vue";
import SerialNode from "@/components/flow/nodes/serial-node.vue";
import IteratorItemNode from "@/components/flow/nodes/iterator-item-node.vue";

export default {
	name: 'IteratorNode',
	props: {
		_config: {
			type: Object, default: () => ({})
		},
		_parent: {
			type: Object, default: () => ({})
		},
		_define: {
			type: Object, default: () => ({})
		},
		_index:{
			type:Number,
		}
	},
	components: {
		IteratorItemNode,
		SerialNode,
		FlowNode,
		ConditionNode,
		FlowRender,
		BranchAction,
		FlowAction,
		AddAction
	},
	setup(props) {
		const handlerAddNode = (config) => {
			// console.log(name)
			props._config.children.push(Object.assign(config?.default() || {}, {
				name: config.name
			}))
		}
		return {
			handlerAddNode
		}
	}
}
</script>

<style lang="scss" scoped>
.add-branch {
	justify-content: center;
	padding: 0px 10px;
	position: absolute;
	top: -16px;
	left: 50%;
	transform: translateX(-50%);
	transform-origin: center center;
	z-index: 1;
	display: inline-flex;
	align-items: center;
}

.branch-wrap {
	display: inline-flex;
	width: 100%;
}

.branch-box-wrap {
	display: flex;
	flex-flow: column wrap;
	align-items: center;
	min-height: 200px;
	width: 100%;
	flex-shrink: 0;
}

.col-box {
	display: inline-flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	background: #f6f8f9;
	justify-content: center;
}

.branch-box {
	display: flex;
	overflow: visible;
	min-height: 180px;
	height: auto;
	border-bottom: 2px solid #ccc;
	border-top: 2px solid #ccc;
	position: relative;
	//margin-top: 15px;
}

.branch-box .col-box::before {
	content: "";
	position: absolute;
	top: 0px;
	left: 0px;
	right: 0px;
	bottom: 0px;
	z-index: 0;
	margin: auto;
	width: 2px;
	height: 100%;
	background-color: rgb(202, 202, 202);
}

.top-left-cover-line, .top-right-cover-line {
	position: absolute;
	height: 3px;
	width: 50%;
	background-color: #f6f8f9;
	top: -2px;
}

.bottom-left-cover-line, .bottom-right-cover-line {
	position: absolute;
	height: 3px;
	width: 50%;
	background-color: #f6f8f9;
	bottom: -2px;
}

.top-left-cover-line {
	left: -1px;
}

.top-right-cover-line {
	right: -1px;
}

.bottom-left-cover-line {
	left: -1px;
}

.bottom-right-cover-line {
	right: -1px;
}

.iterator-node {
	padding-top: 20px;
}

</style>
